import React, { useEffect, useMemo, useState } from 'react'
import { Table, FormInput, Row, Button, Widget, ColumnProps, FormSelect } from '@digital/ui';
import { Collapse, Icon } from 'antd';
import ptBR from '@app/i18n/ptBR'
import { orcadoAnoParametroState, solicitacaoIdState, solicitacaoState } from '../../../atoms';
import { useRecoilValue } from 'recoil';
import { OrcamentoSolicitacaoNaoPrevisto, updateOrcamentoSolicitacaoNaoPrevisto, deleteOrcamentoSolicitacaoNaoPrevisto, getOrcamentoSolicitacaoNaoPrevisto, updateAllOrcamentoFinanceiroSolicitacaoNaoPrevisto, updateOrcamentoFinanceiroSolicitacaoNaoPrevisto } from '@app/api/naoPrevistos/orcamentoSolicitacao';
import { CurrencyInput3 } from '@app/components/CurrencyInput3';
import { currencyFormatSemAbreviacao } from '@app/helpers/numbers';
import { EStatusSolicitacaoNaoPrevisto, ETipoNaoPrevisto } from '@app/enums/ENaoPrevisto';
import { Visibility } from '@app/components/Visibility';


const { Panel } = Collapse;
const OrcamentoFinanceiro = ({ list, setList, orcamentos, setOrcamentos, acronimos, contasContabil, noCollapse }: any) => {
  const idSolicitacao = useRecoilValue(solicitacaoIdState);
  const solicitacao = useRecoilValue(solicitacaoState);
  const orcadoAnoNaoPrevisto = useRecoilValue(orcadoAnoParametroState);

  const getLista = () => {
    if (idSolicitacao === undefined) return
    getOrcamentoSolicitacaoNaoPrevisto(idSolicitacao).then((response) => {
      if (response) {
        const newOrcamentoList = response.map((item) => {
          return { ...item }
        })
        setList([...response])
        setOrcamentos(newOrcamentoList)
      }
    })
  }
  
  const handleEdit = (item: any) => {
    const itemDefault = orcamentos.find((i) => i.id === item.id)
    if (itemDefault === undefined) return
    if (JSON.stringify(itemDefault) === JSON.stringify(item)) return

    updateOrcamentoSolicitacaoNaoPrevisto(item).then((response) => {
      if (response) {
        getLista()
      }
    })
  }

  const handleAdd = () => {
    if (idSolicitacao === undefined) return

    updateAllOrcamentoFinanceiroSolicitacaoNaoPrevisto({ solicitacaoNaoPrevistoId: idSolicitacao }).then((response) => {
      if (response) {
        getLista()
      }
    })
  }

  const handleRemove = (id: string) => {
    updateOrcamentoFinanceiroSolicitacaoNaoPrevisto({ id }).then((response) => {
      if (response) {
        getLista()
      }
    })
  }

  const creatTitleCalculado = (totalEmReais?: number) => {
    if (totalEmReais) {
      return <span>{ptBR.lblTotalReais}: {currencyFormatSemAbreviacao(totalEmReais)} <br></br> {ptBR.lblTotalDolar}: {currencyFormatSemAbreviacao(totalEmReais / (orcadoAnoNaoPrevisto.valorDolar ?? 0))} </span>
      return `${ptBR.lblTotalReais}: ${totalEmReais}`
    }

    return ``
  }

  const columnsMeses: ColumnProps<any>[] = [
    {
      title: `${ptBR.lblJaneiro}`,
      dataIndex: 'janeiroFinanceiro',
      children: [
        {
          // title: creatTitleCalculado(100),
          title: creatTitleCalculado(list.reduce((n, { janeiroFinanceiro }) => n + (janeiroFinanceiro || 0), 0)),
          dataIndex: 'janeiroFinanceiro',
          width: '180px',
          render(text, record, index) {
            return (
              <CurrencyInput3
                name={`janeiroFinanceiro`}
                span={12}
                value={record.janeiroFinanceiro}
                onChange={e => record.janeiroFinanceiro = e}
                onBlur={() => handleEdit(record)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    handleEdit(record)
                  }
                }}
                disabled={solicitacao.statusId !== EStatusSolicitacaoNaoPrevisto.PreenchimentoDaSolicitacao}
              />
            )
          },
        },
      ],
    },
    {
      title: `${ptBR.lblFevereiro}`,
      dataIndex: 'fevereiroFinanceiro',
      children: [
        {
          title: creatTitleCalculado(list.reduce((n, { fevereiroFinanceiro }) => n + (fevereiroFinanceiro || 0), 0)),
          dataIndex: 'fevereiroFinanceiro',
          width: '180px',
          render(text, record, index) {
            return (
              <CurrencyInput3
                name={`fevereiroFinanceiro`}
                span={12}
                value={record.fevereiroFinanceiro}
                onChange={e => record.fevereiroFinanceiro = e}
                onBlur={() => handleEdit(record)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    handleEdit(record)
                  }
                }}
                disabled={solicitacao.statusId !== EStatusSolicitacaoNaoPrevisto.PreenchimentoDaSolicitacao}
              />
            )
          },
        },
      ]
    },
    {
      title: `${ptBR.lblMarco}`,
      dataIndex: 'marcoFinanceiro',
      children: [
        {
          title: creatTitleCalculado(list.reduce((n, { marcoFinanceiro }) => n + (marcoFinanceiro || 0), 0)),
          dataIndex: 'marcoFinanceiro',
          width: '180px',
          render(text, record, index) {
            return (
              <CurrencyInput3
                name={`marcoFinanceiro`}
                span={12}
                value={record.marcoFinanceiro}
                onChange={e => record.marcoFinanceiro = e}
                onBlur={() => handleEdit(record)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    handleEdit(record)
                  }
                }}
                disabled={solicitacao.statusId !== EStatusSolicitacaoNaoPrevisto.PreenchimentoDaSolicitacao}
              />
            )
          },
        },
      ]
    },
    {
      title: `${ptBR.lblAbril}`,
      dataIndex: 'abrilFinanceiro',
      children: [
        {
          title: creatTitleCalculado(list.reduce((n, { abrilFinanceiro }) => n + (abrilFinanceiro || 0), 0)),
          dataIndex: 'abrilFinanceiro',
          width: '180px',
          render(text, record, index) {
            return (
              <CurrencyInput3
                name={`abrilFinanceiro`}
                span={12}
                value={record.abrilFinanceiro}
                onChange={e => record.abrilFinanceiro = e}
                onBlur={() => handleEdit(record)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    handleEdit(record)
                  }
                }}
                disabled={solicitacao.statusId !== EStatusSolicitacaoNaoPrevisto.PreenchimentoDaSolicitacao}
              />
            )
          },
        },
      ]
    },
    {
      title: `${ptBR.lblMaio}`,
      dataIndex: 'maioFinanceiro',
      children: [
        {
          title: creatTitleCalculado(list.reduce((n, { maioFinanceiro }) => n + (maioFinanceiro || 0), 0)),
          dataIndex: 'maioFinanceiro',
          width: '180px',
          render(text, record, index) {
            return (
              <CurrencyInput3
                name={`maio`}
                span={12}
                value={record.maioFinanceiro}
                onChange={e => record.maioFinanceiro = e}
                onBlur={() => handleEdit(record)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    handleEdit(record)
                  }
                }}
                disabled={solicitacao.statusId !== EStatusSolicitacaoNaoPrevisto.PreenchimentoDaSolicitacao}
              />
            )
          },
        },
      ]
    },
    {
      title: `${ptBR.lblJunho}`,
      dataIndex: 'junhoFinanceiro',
      children: [
        {
          title: creatTitleCalculado(list.reduce((n, { junhoFinanceiro }) => n + (junhoFinanceiro || 0), 0)),
          dataIndex: 'junhoFinanceiro',
          width: '180px',
          render(text, record, index) {
            return (
              <CurrencyInput3
                name={`junhoFinanceiro`}
                span={12}
                value={record.junhoFinanceiro}
                onChange={e => record.junhoFinanceiro = e}
                onBlur={() => handleEdit(record)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    handleEdit(record)
                  }
                }}
                disabled={solicitacao.statusId !== EStatusSolicitacaoNaoPrevisto.PreenchimentoDaSolicitacao}
              />
            )
          },
        },
      ]
    },
    {
      title: `${ptBR.lblJulho}`,
      dataIndex: 'julhoFinanceiro',
      children: [
        {
          title: creatTitleCalculado(list.reduce((n, { julhoFinanceiro }) => n + (julhoFinanceiro || 0), 0)),
          dataIndex: 'julhoFinanceiro',
          width: '180px',
          render(text, record, index) {
            return (
              <CurrencyInput3
                name={`julhoFinanceiro`}
                span={12}
                value={record.julhoFinanceiro}
                onChange={e => record.julhoFinanceiro = e}
                onBlur={() => handleEdit(record)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    handleEdit(record)
                  }
                }}
                disabled={solicitacao.statusId !== EStatusSolicitacaoNaoPrevisto.PreenchimentoDaSolicitacao}
              />
            )
          },
        },
      ]
    },
    {
      title: `${ptBR.lblAgosto}`,
      dataIndex: 'agosto',
      children: [
        {
          title: creatTitleCalculado(list.reduce((n, { agostoFinanceiro }) => n + (agostoFinanceiro || 0), 0)),
          dataIndex: 'agostoFinanceiro',
          width: '180px',
          render(text, record, index) {
            return (
              <CurrencyInput3
                name={`agostoFinanceiro`}
                span={12}
                value={record.agostoFinanceiro}
                onChange={e => record.agostoFinanceiro = e}
                onBlur={() => handleEdit(record)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    handleEdit(record)
                  }
                }}
                disabled={solicitacao.statusId !== EStatusSolicitacaoNaoPrevisto.PreenchimentoDaSolicitacao}
              />
            )
          },
        },
      ]
    },
    {
      title: `${ptBR.lblSetembro}`,
      dataIndex: 'setembroFinanceiro',
      children: [
        {
          title: creatTitleCalculado(list.reduce((n, { setembroFinanceiro }) => n + (setembroFinanceiro || 0), 0)),
          dataIndex: 'setembroFinanceiro',
          width: '180px',
          render(text, record, index) {
            return (
              <CurrencyInput3
                name={`setembroFinanceiro`}
                span={12}
                value={record.setembroFinanceiro}
                onChange={e => record.setembroFinanceiro = e}
                onBlur={() => handleEdit(record)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    handleEdit(record)
                  }
                }}
                disabled={solicitacao.statusId !== EStatusSolicitacaoNaoPrevisto.PreenchimentoDaSolicitacao}
              />
            )
          },
        },
      ]
    },
    {
      title: `${ptBR.lblOutubro}`,
      dataIndex: 'outubroFinanceiro',
      children: [
        {
          title: creatTitleCalculado(list.reduce((n, { outubroFinanceiro }) => n + (outubroFinanceiro || 0), 0)),
          dataIndex: 'outubroFinanceiro',
          width: '180px',
          render(text, record, index) {
            return (
              <CurrencyInput3
                name={`outubroFinanceiro`}
                span={12}
                value={record.outubroFinanceiro}
                onChange={e => record.outubroFinanceiro = e}
                onBlur={() => handleEdit(record)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    handleEdit(record)
                  }
                }}
                disabled={solicitacao.statusId !== EStatusSolicitacaoNaoPrevisto.PreenchimentoDaSolicitacao}
              />
            )
          }
        },
      ]
    },
    {
      title: `${ptBR.lblNovembro}`,
      dataIndex: 'novembroFinanceiro',
      children: [
        {
          title: creatTitleCalculado(list.reduce((n, { novembroFinanceiro }) => n + (novembroFinanceiro || 0), 0)),
          dataIndex: 'novembroFinanceiro',
          width: '180px',
          render(text, record, index) {
            return (
              <CurrencyInput3
                name={`novembroFinanceiro`}
                span={12}
                value={record.novembroFinanceiro}
                onChange={e => record.novembroFinanceiro = e}
                onBlur={() => handleEdit(record)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    handleEdit(record)
                  }
                }}
                disabled={solicitacao.statusId !== EStatusSolicitacaoNaoPrevisto.PreenchimentoDaSolicitacao}
              />
            )
          }
        },
      ]
    },
    {
      title: `${ptBR.lblDezembro}`,
      dataIndex: 'dezembroFinanceiro',
      children: [
        {
          title: creatTitleCalculado(list.reduce((n, { dezembroFinanceiro }) => n + (dezembroFinanceiro || 0), 0)),
          dataIndex: 'dezembroFinanceiro',
          width: '180px',
          render(text, record, index) {
            return (
              <CurrencyInput3
                name={`dezembro`}
                span={12}
                value={record.dezembroFinanceiro}
                onChange={e => record.dezembroFinanceiro = e}
                onBlur={() => handleEdit(record)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    handleEdit(record)
                  }
                }}
                disabled={solicitacao.statusId !== EStatusSolicitacaoNaoPrevisto.PreenchimentoDaSolicitacao}
              />
            )
          }
        },
      ]
    },
    {
      title: `${ptBR.lblTotal}`,
      dataIndex: 'totalFinanceiro',
      children: [
        {
          title: creatTitleCalculado(list.reduce((n, { totalFinanceiro }) => n + (totalFinanceiro || 0), 0)),
          dataIndex: 'totalFormatadoFinanceiro',
          width: '10%',
        },
      ]
    }
  ]

  const columns = useMemo(() => {
    const collumns: ColumnProps<any>[] = []

    if (solicitacao === undefined) return collumns

    collumns.push({
      title: 'N',
      dataIndex: 'index',
    })

    if (solicitacao.tipo.toUpperCase() === ETipoNaoPrevisto.CNP.toUpperCase()) {
      collumns.push(
        {
          title: `${ptBR.lblSigla}`,
          width: '150px',
          render(text, record, index) {
            //unique sigla
            let siglas = acronimos.flatMap((item) => item.sigla)
            siglas = [...new Set(siglas)]
            return (
              <FormSelect
                name='sigla'
                span={12}
                value={record.sigla}
                options={siglas.map((item) => ({ text: item, value: item }))}
                allowClear
                disabled={true}
              />
            )
          },
        }
      )

      collumns.push(
        {
          title: `${ptBR.lblDisciplina}`,
          width: '150px',
          render(text, record, index) {
            let acronimosTemp = [...acronimos]

            if (record.sigla !== undefined && record.sigla !== null)
              acronimosTemp = acronimosTemp.filter((item) => item.sigla === record.sigla)
            else if (record.tipo !== undefined && record.tipo !== null)
              acronimosTemp = acronimosTemp.filter((item) => item.tipoNome === record.tipo)

            let disciplinas = acronimosTemp.flatMap((item) => item.disciplinaNome)
            disciplinas = [...new Set(disciplinas)]
            disciplinas = disciplinas.sort()
            return (
              <FormSelect
                name='disciplina'
                span={12}
                value={record.disciplina}
                options={disciplinas.map((item) => ({ text: item, value: item }))}
                allowClear
                disabled={true}
              />
            )
          },
        }
      )

      collumns.push(
        {
          title: `${ptBR.lblTipo}`,
          width: '150px',
          render(text, record, index) {
            let acronimosTemp = [...acronimos]

            if (record.sigla !== undefined && record.sigla !== null)
              acronimosTemp = acronimosTemp.filter((item) => item.sigla === record.sigla)
            else if (record.disciplina !== undefined && record.disciplina !== null)
              acronimosTemp = acronimosTemp.filter((item) => item.disciplinaNome === record.disciplina)

            //unique tipo
            let tipos = acronimosTemp.flatMap((item) => item.tipoNome)
            tipos = [...new Set(tipos)]

            return (
              <FormSelect
                name='tipo'
                span={12}
                value={record.tipo}
                options={tipos.map((item) => ({ text: item, value: item }))}
                allowClear
                disabled={true}
              />
            )
          },
        }
      )

      // collumns.push(
      //   {
      //     title: `${ptBR.lblPacoteTipoEDisciplina}`,
      //     dataIndex: 'pacote',
      //     width: '100px',
      //     render(text, record, index) {
      //       return (
      //         <FormInput
      //           span={12}
      //           name={`pacote`}
      //           value={record.pacote}
      //           disabled={true}
      //         />
      //       )
      //     },
      //   }
      // )
    }

    if (solicitacao.tipo.toUpperCase() === ETipoNaoPrevisto.ONP.toUpperCase()) {
      collumns.push(
        {
          title: `Natureza`,
          width: '150px',
          render(text, record, index) {
            //unique contas
            let contas = contasContabil.flatMap((item) => item.codigo)
            contas = [...new Set(contas)]

            return (
              <FormSelect
                name='contaContabil'
                span={12}
                value={record.contaContabil}
                options={contas.map((item) => ({ text: item, value: item }))}
                filterOption={(input, item) => {
                  return item.props.children.props.id
                    .toString()
                    .toLowerCase()
                    .includes(input.toLowerCase());
                }}
                showSearch
                allowClear
                disabled={true}
              />
            )
          },
        }
      )

      collumns.push(
        {
          title: `${ptBR.lblAgrupador}`,
          width: '150px',
          render(text, record, index) {
            return (
              <FormInput
                span={12}
                name={`agrupador`}
                value={record.agrupador}
                disabled={true}
              />
            )
          }
        }
      )
    }

    collumns.push(
      {
        title: `${ptBR.lblDescricaoDoPacote}`,
        dataIndex: 'descricaoPacote',
        width: '300px',
        render(text, record, index) {
          return (
            <FormInput
              span={12}
              name={`descricaoPacote`}
              value={record.descricaoPacote}
              disabled={true}
            />
          )
        },
      }
    )

    collumns.push(...columnsMeses)

    collumns.push(
      {
        title: `${ptBR.lblAcao}`,
        dataIndex: 'acao',
        fixed: 'right',
        render(text, record, index) {
          return (
            <Visibility visible={solicitacao.statusId === EStatusSolicitacaoNaoPrevisto.PreenchimentoDaSolicitacao} >
              <Button
                confirm="Deseja realmente atualizar este registro?"
                okText="Confirmar"
                icon='business-deposit'
                onClick={() => handleRemove(record.id)} />
            </Visibility>
          )
        }
      }
    )

    return collumns
  }, [solicitacao, acronimos, contasContabil, list, orcamentos])

  const content = (
        <Widget
          title=""
          actions={[]}>
          <Row>
            <Visibility visible={solicitacao.statusId === EStatusSolicitacaoNaoPrevisto.PreenchimentoDaSolicitacao} >
              <Button
                confirm="Deseja realmente atualizar todos os registro?"
                okText="Confirmar"
                style={{ float: 'inline-end' }} icon='business-deposit' type='link' onClick={handleAdd} />
            </Visibility>
          </Row>
          <Row>
            <div style={{ width: '100%', overflowX: 'auto', overflowY: 'hidden' }}>
              <Table
                dataSource={list}
                columns={columns}
                rowKey="id"
                pagination={false}
              />
            </div>
          </Row>
        </Widget>
  );

  if (noCollapse) return content;
  return (
    <Collapse bordered={false} defaultActiveKey={['2']} expandIcon={() => <Icon type="arrows-right_4" />}>
      <Panel key="2" header={ptBR.lblOrcamentoFinanceiro} style={{ border: 0 }}>
        {content}
      </Panel>
    </Collapse>
  );
}

export default OrcamentoFinanceiro